import apiClient from '../api/client.js';

// Static fallback data
export const staticCountries = [
  { country_id: 1, country_code: 'SG', country_name: 'Singapore', phone_code: '+65', currency_code: 'SGD', currency_symbol: 'S$', language_code: 'en' },
  { country_id: 2, country_code: 'MY', country_name: 'Malaysia', phone_code: '+60', currency_code: 'MYR', currency_symbol: 'RM', language_code: 'ms' },
  { country_id: 3, country_code: 'TH', country_name: 'Thailand', phone_code: '+66', currency_code: 'THB', currency_symbol: '฿', language_code: 'th' },
  { country_id: 4, country_code: 'ID', country_name: 'Indonesia', phone_code: '+62', currency_code: 'IDR', currency_symbol: 'Rp', language_code: 'id' },
  { country_id: 5, country_code: 'PH', country_name: 'Philippines', phone_code: '+63', currency_code: 'PHP', currency_symbol: '₱', language_code: 'en' },
  { country_id: 6, country_code: 'VN', country_name: 'Vietnam', phone_code: '+84', currency_code: 'VND', currency_symbol: '₫', language_code: 'vi' },
  { country_id: 7, country_code: 'US', country_name: 'United States', phone_code: '+1', currency_code: 'USD', currency_symbol: '$', language_code: 'en' },
  { country_id: 8, country_code: 'GB', country_name: 'United Kingdom', phone_code: '+44', currency_code: 'GBP', currency_symbol: '£', language_code: 'en' },
  { country_id: 9, country_code: 'AU', country_name: 'Australia', phone_code: '+61', currency_code: 'AUD', currency_symbol: 'A$', language_code: 'en' }
];

export const countryService = {
  getAllCountries: async () => {
    try {
      console.log('🌍 Fetching countries from:', apiClient.defaults.baseURL);
      const response = await apiClient.get('/api/v1/countries');
      
      // Fix the duplicate condition ESLint error
      if (response.data?.data) {
        return response.data.data;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('❌ Error fetching countries:', error.response?.status, error.message);
      
      // Log more details for debugging
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      
      console.log('🔄 Falling back to static countries data');
      return staticCountries;
    }
  },

  getCountryById: async (countryId) => {
    try {
      const response = await apiClient.get(`/api/v1/countries/${countryId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching country, using static data:', error);
      return staticCountries.find(c => c.country_id === parseInt(countryId));
    }
  },

  getCountryByCode: async (countryCode) => {
    try {
      const response = await apiClient.get(`/api/v1/countries/code/${countryCode}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching country by code, using static data:', error);
      return staticCountries.find(c => c.country_code === countryCode.toUpperCase());
    }
  },

  detectUserCountry: async () => {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      
      if (data.country_code) {
        return await countryService.getCountryByCode(data.country_code);
      }
      
      return await countryService.getCountryByCode('SG');
    } catch (error) {
      console.error('Error detecting user country:', error);
      return staticCountries.find(c => c.country_code === 'SG');
    }
  }
};